module.exports = __webpack_public_path__ + "img/37.27691fca.jpg";